module.exports = __webpack_public_path__ + "media/images/av-logo-horizontal-white-3e23a7c7d8e87cf3e3d416b38eec0f99.svg";